import { headers } from "@utils/utils";
const useLoteStore = defineStore("lote", () => {
  // state
  const lote = ref({
    id: null,
    paginas: 0,
    precio: 0,
    imagen: null,
    descuento_id: null,
    planes: [],
  });

  const lotes = ref([]);

  // getters

  const draft = computed(() => clone(lote.value));

  // mutations

  const setLote = (payload) => {
    lote.value = payload;
  };

  const clear = () => {
    lote.value = {
      id: null,
      paginas: 0,
      precio: 0,
      imagen: null,
      descuento_id: null,
      planes: [],
    };
  };

  const setLotes = (payload) => (lotes.value = payload);

  // actions
  const fetch = (lote_id) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/lotes/${lote_id}/fetch-data`)
        .then(({ data }) => {
          setLote(data);
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  const fetchData = (params) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`api/lotes/fetch-data`, params)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  const guardar = (datos) => {
    let formData = new FormData();
    Object.keys(datos).forEach((k) => {
      formData.append(k, datos[k]);
    });

    return new Promise((resolve, reject) => {
      if (datos.id) {
        formData.append("_method", "PUT");

        axios
          .post(`/api/lotes/${datos.id}`, formData, { headers })
          .then(({ data }) => resolve(data))
          .catch((e) => reject(e));
      } else {
        axios
          .post(`/api/lotes`, formData, { headers })
          .then(({ data }) => resolve(data))
          .catch((e) => reject(e));
      }
    });
  };

  const eliminar = (lote_id) => {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/lotes/${lote_id}`)
        .then(({ data }) => resolve(data))
        .catch((e) => reject(e));
    });
  };

  const fetchListSelect = () => {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/lotes/fetch-list-select`)
        .then(({ data }) => resolve(data))
        .catch((e) => reject(e));
    });
  };

  const fetchPlansByLote = async (lote_id) => {
    try {
      const { data } = await axios.get(`/api/lotes/${lote_id}/fetch-plans`);
      return data;
    } catch (error) {
      throw error;
    }
  };

  const asignarPlan = async (datos) => {
    try {
      const { data } = await axios.put(
        `/api/lotes/${datos.lote_id}/asignar-precio-plan`,
        datos
      );
      return data;
    } catch (error) {
      throw error;
    }
  };

  const eliminarPrecio = async (lote_id, plan_id) => {
    try {
      const { data } = await axios.get(
        `/api/lotes/${lote_id}/quitar-plan/${plan_id}`
      );
      return data;
    } catch (error) {
      throw error;
    }
  };

  return {
    lote,
    draft,
    setLote,
    setLotes,
    fetch,
    clear,
    fetchData,
    guardar,
    eliminar,
    fetchListSelect,
    fetchPlansByLote,
    asignarPlan,
    eliminarPrecio,
  };
});

export default useLoteStore;
